/**
 * prospectiveTenants.js
 * copyright © 2022 Ania Management
 */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { prospectiveTenantsdata } from "../prospectiveTenantsLayout";
import parse from "html-react-parser";

import "../assets/css/aboutus.css";

function ProspectiveTenants() {
  const { pathname } = useLocation();
  let urlTosearch = pathname.split("/");
  urlTosearch = urlTosearch[1];
  const [pageData, setPageData] = useState([]);

  //for opening page from top whenever user lands on this page
  useEffect(() => {
    window.scrollTo(0, 0);
    if (urlTosearch) {
      const result = prospectiveTenantsdata.filter(
        (val) => val.url.toLowerCase() === urlTosearch.toLowerCase()
      );
      if (result && result.length > 0) {
        setPageData(result);
      } else {
        setPageData([]);
      }
    }
  }, [urlTosearch]);

  return (
    <section className="content-wrapper about-us">
      {pageData && pageData.length > 0 ? (
        <div className="ania-content pt-lg-1 pt-0">
          <div className="container-fluid px-0">
            <div className="main-content">
              <div className="col-lg-12 px-lg-5 px-4">
                <h1 className="page-title page-title-lg mb-0">
                  {pageData[0].pageTitle}
                </h1>
              </div>
            </div>
          </div>
          <div className="container-fluid px-0">
            <div className="about-us-img">
              <img
                src={pageData[0].mobileImg}
                alt="about us mobile img"
                className="mobile-img img-main"
              />
              <img
                src={pageData[0].desktopImg}
                alt="about us desktop img"
                className="desktop-img img-main"
              />
            </div>
            <div className="container-width">
              <div className="about-us-content">
                <h2 className="text-center">{pageData[0].title}</h2>
                <p>{parse(pageData[0].p1)}</p>
                <p>{parse(pageData[0].p2)}</p>
                <p>{parse(pageData[0].p3)}</p>
                <div className="sub-heading4">{pageData[0].subHeading3}</div>
                <ul>
                  <li>{pageData[0].list1.l1}</li>
                  <li>{pageData[0].list1.l2}</li>
                  <li>{pageData[0].list1.l3}</li>
                </ul>
                <div className="sub-heading4">{pageData[0].subHeading4}</div>
                <ul>
                  <li>{pageData[0].list2.l1}</li>
                  <li>{pageData[0].list2.l2}</li>
                  <li>{pageData[0].list2.l3}</li>
                </ul>
                <br />
                <br />
                <p>{parse(pageData[0].p4)}</p>
                <p>{parse(pageData[0].p5)}</p>
                <p>{parse(pageData[0].p6)}</p>
                <p>{parse(pageData[0].p7)}</p>
                <p>{parse(pageData[0].p8)}</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <h1
          style={{ textAlign: "center", margin: "120px 50px", color: "grey" }}
        >
          {" "}
          No Data Found For This Url
        </h1>
      )}
    </section>
  );
}

export default ProspectiveTenants;
